import { LOGIN_API_URL } from "../constants";

class FeatureFlagApi {
  constructor() {
    this.baseUrl = LOGIN_API_URL || "";
  }

  async getAllFlags() {
    try {
      const response = await fetch(`${this.baseUrl}/feature_flags`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data.flags;
    } catch (error) {
      console.error("Failed to fetch feature flags:", error);
      return FeatureFlagApi.getFallbackFlags();
    }
  }

  static getFallbackFlags() {
    return {
      socialSignin: false,
    };
  }
}

export default new FeatureFlagApi();
